import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 실제 구현에서는 서버로 전송
    console.log('문의 내용:', formData);
    setIsSubmitted(true);
    // 폼 초기화
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="bg-gradient-primary min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            
            {/* 헤더 */}
            <div className="text-center py-5">
              <h1 className="h1 text-white mb-4">
                <i className="fas fa-envelope me-3"></i>
                문의하기
              </h1>
              <p className="lead text-white-50 mb-0">
                서비스 개선 사항이나 문의사항을 보내주세요
              </p>
            </div>

            {/* 문의 양식 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  <i className="fas fa-paper-plane me-2"></i>
                  문의 양식
                </h3>
              </div>
              <div className="card-body">
                {isSubmitted && (
                  <div className="alert alert-success alert-dismissible fade show" role="alert">
                    <i className="fas fa-check-circle me-2"></i>
                    <strong>문의가 성공적으로 전송되었습니다!</strong> 빠른 시일 내에 검토 후 답변드리겠습니다.
                    <button type="button" className="btn-close" onClick={() => setIsSubmitted(false)}></button>
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="name" className="form-label">
                        <i className="fas fa-user me-2"></i>이름 *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="이름을 입력해주세요"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label">
                        <i className="fas fa-envelope me-2"></i>이메일 *
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="subject" className="form-label">
                      <i className="fas fa-tag me-2"></i>문의 유형 *
                    </label>
                    <select
                      className="form-control"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">문의 유형을 선택해주세요</option>
                      <option value="feature">새로운 기능 제안</option>
                      <option value="bug">버그 신고</option>
                      <option value="calculation">계산 방식 문의</option>
                      <option value="general">일반 문의</option>
                      <option value="partnership">제휴 문의</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="message" className="form-label">
                      <i className="fas fa-comment me-2"></i>문의 내용 *
                    </label>
                    <textarea
                      className="form-control"
                      id="message"
                      name="message"
                      rows="6"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      placeholder="자세한 문의 내용을 입력해주세요..."
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button type="submit" className="btn btn-primary btn-lg px-5">
                      <i className="fas fa-paper-plane me-2"></i>
                      문의 보내기
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* 자주 묻는 질문 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  <i className="fas fa-question-circle me-2"></i>
                  자주 묻는 질문 (FAQ)
                </h3>
              </div>
              <div className="card-body">
                <div className="accordion" id="faqAccordion">
                  
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="heading1">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1">
                        <i className="fas fa-calculator me-2"></i>
                        계산 결과가 정확한가요?
                      </button>
                    </h2>
                    <div id="collapse1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        <p>본 계산기는 <strong>참고용</strong>으로 제작되었으며, 다음과 같은 가정을 바탕으로 합니다:</p>
                        <ul>
                          <li>연 수익률이 일정하다고 가정 (실제로는 변동)</li>
                          <li>인플레이션, 세금, 수수료 등은 별도 고려 필요</li>
                          <li>실제 투자 결정 시에는 전문가와 상담 권장</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="heading2">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2">
                        <i className="fas fa-mobile-alt me-2"></i>
                        모바일에서도 사용할 수 있나요?
                      </button>
                    </h2>
                    <div id="collapse2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        네, 반응형 웹 디자인으로 제작되어 스마트폰, 태블릿, PC 모든 기기에서 최적화된 화면으로 사용하실 수 있습니다.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="heading3">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3">
                        <i className="fas fa-shield-alt me-2"></i>
                        개인정보는 안전한가요?
                      </button>
                    </h2>
                    <div id="collapse3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        본 서비스는 어떠한 개인정보도 저장하지 않습니다. 모든 계산은 브라우저에서 실시간으로 처리되며, 입력하신 데이터는 서버에 전송되지 않습니다.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="heading4">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4">
                        <i className="fas fa-chart-line me-2"></i>
                        어떤 투자 상품에 적용할 수 있나요?
                      </button>
                    </h2>
                    <div id="collapse4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        <p>다음과 같은 투자 상품에 참고하실 수 있습니다:</p>
                        <ul>
                          <li><strong>연금저축:</strong> 세액공제 혜택이 있는 노후 준비 상품</li>
                          <li><strong>IRP (개인형 퇴직연금):</strong> 퇴직금을 연금으로 운용</li>
                          <li><strong>ISA:</strong> 개인종합자산관리계좌</li>
                          <li><strong>ETF/펀드:</strong> 장기 투자용 상품</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* 연락처 정보 */}
            <div className="card shadow mb-4">
              <div className="card-body text-center">
                <h5 className="text-primary mb-3">
                  <i className="fas fa-info-circle me-2"></i>
                  추가 정보
                </h5>
                <p className="text-gray-600 mb-3">
                  더 궁금한 사항이 있으시거나 파트너십을 원하시는 경우<br/>
                  언제든지 문의해 주시기 바랍니다.
                </p>
                <div className="text-muted">
                  <small>
                    <i className="fas fa-clock me-1"></i>
                    문의 답변은 영업일 기준 1-2일 내에 처리됩니다.
                  </small>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;